import { connect } from "react-redux";
import AllValetList from "./AllValetList";
import { bindActionCreators } from "redux";
import { getValetListData } from "services/redux/Valet/Supervisor/action";
const mapStateToProps = (state) => ({
    valetListData: state.CreateSupervisor.valetListData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getValetListData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AllValetList);
